import { AppIcons } from "../data/appIcons";

export const getFileIcon = (type) => {
  if (type.includes("pdf")) return AppIcons.PdfIcon;
  if (type.includes("msword") || type.includes("wordprocessingml") || type.includes("docx") || type.includes("txt"))
    return AppIcons.DocIcon;
  if (type.includes("excel") || type.includes("spreadsheetml") || type.includes("xlsx"))
    return AppIcons.XlsIcon;
  if (type.includes("presentationml")) return AppIcons.PptIcon;
  if (type.includes("csv")) return AppIcons.CsvIcon;
  if (type.includes("jpg") || type.includes("png") || type.includes("jpeg"))
    return AppIcons.ImgIcon;
  if (type.includes("zip") || type.includes("x-zip-compressed"))
    return AppIcons.ZipIcon;
  return AppIcons.DefaultIcon;
};
